import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  summary: string;
  price: string;
  image: string;
  link: string;
}
export function ServiceCard({
  title,
  summary,
  price,
  image,
  link
}: ServiceCardProps) {
  return <div className="bg-white rounded-2xl overflow-hidden shadow-soft flex flex-col h-full transition-transform duration-300 hover:-translate-y-1" data-id="element-170">
      <div className="aspect-[4/3] overflow-hidden" data-id="element-171">
        <img src={image} alt={title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-172" />
      </div>

      <div className="p-8 flex flex-col flex-grow" data-id="element-173">
        <h3 className="text-2xl font-serif text-charcoal mb-4 leading-tight" data-id="element-174">
          {title}
        </h3>
        <p className="text-charcoal-50 font-light leading-relaxed mb-6 flex-grow" data-id="element-175">
          {summary}
        </p>

        <div className="mt-auto pt-6 border-t border-cream-200" data-id="element-176">
          <p className="text-sage-700 font-medium mb-6" data-id="element-177">{price}</p>

          <div className="flex items-center justify-between" data-id="element-178">
            <Link to="/contact" className="bg-sage text-white px-6 py-2.5 rounded-full text-sm tracking-wide hover:bg-sage-600 transition-colors" data-id="element-179">
              Join a Session
            </Link>
            <Link to={link} className="flex items-center text-sm text-charcoal-50 hover:text-sage-700 transition-colors group" data-id="element-180">
              Discover More
              <ArrowRight size={16} className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-181" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
}